import React from 'react';
import PropTypes from 'prop-types';
import { Portal } from 'react-portal';

import { ButtonsCollection, ScrollWrapper } from '..';
import './style.sass';

const ModalWindow = ({
  title,
  children,
  position,
  isOpen,
  onClose,
  className,
  setRef,
}) => (
  <Portal>
    {isOpen
      && (
        <div className={`modal-window ${className}`} ref={e => setRef('modalContainer', e)}>
          <ScrollWrapper className="modal-window__scroll-wrapper" heightIs="var(--app-height)">
            <div
              className={`modal-window__container ${
                position ? `modal-window__container--align-${position}` : ''
              }`}
              ref={e => setRef('bodyModal', e)}
            >
              <div className="modal-window__header">
                <h3 className="modal-window__title text--center title--big text--cut">
                  {title}
                </h3>
                <ButtonsCollection.ButtonClose onClick={onClose} />
              </div>
              <div className="modal-window__body">{children}</div>
            </div>
          </ScrollWrapper>
        </div>
      )
    }
  </Portal>
);

ModalWindow.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired,
  position: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  className: PropTypes.string,
  setRef: PropTypes.func.isRequired,
};
ModalWindow.defaultProps = {
  position: '',
  className: '',
};
export default ModalWindow;
